import { createSelector } from 'reselect';
import { createSelector as ormCreateSelector } from 'redux-orm';
import { sortByProperty } from '../../helpers/utilities';
import { orm } from '../models';

// const ormSelector = state => state.orm;

// export const degreeLevelsSelector = createSelector(
//   ormSelector,
//   ormCreateSelector(orm, session =>
//     session.DegreeLevel.all()
//       .toModelArray()
//       .map(degreeLevel => Object.assign({}, degreeLevel.ref))
//       .sort((a, b) => sortByProperty(a, b, 'order'))
//   )
// );

export const degreeLevelsSelector = createSelector(
  state => state,
  redux => {
    const selectorORM = ormCreateSelector([orm], session =>
      session.DegreeLevel.all()
        .toModelArray()
        .map(degreeLevel => Object.assign({}, degreeLevel.ref))
        .sort((a, b) => sortByProperty(a, b, 'order'))
    );
    return selectorORM(redux);
  }
);
